module.exports = __webpack_public_path__ + "media/7.7865e436.wav";